// extracted by mini-css-extract-plugin
export default {"container":"kA-z","heading":"lA-z","text":"mA-z","info":"nA-z","link":"oA-z","fullMaxWidth":"pA-z"};